var render = function render(){var _vm=this,_c=_vm._self._c;return _c('closeable-tag',{attrs:{"active":_vm.active},on:{"close":function($event){return _vm.$emit('close')},"open":function($event){return _vm.$emit('open')}}},[_c('vote-topic-icon',{staticClass:"mr-1",attrs:{"topic":_vm.theme}}),_c('span',{staticClass:"truncate"},[_vm._v(_vm._s(_vm.theme.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }